<template>
    <BaseForm :panels="panels" :action="createAction" :formClass="formClass" :errorMessage="errorMessage" :method="method" :baseMethod="baseMethod" :moduleName="moduleName" :list-link="listLink"></BaseForm>
</template>

<script>
import BaseForm from '../../core/BaseForm'
export default {
  name: 'CustomCreateModule',
  components: {BaseForm},
  props: ['panels', 'apiUrl', 'formClass', 'moduleName', 'listLink'],
  data () {
    return {
      errorMessage: [],
      method: 'POST',
      baseMethod: 'POST',
      createAction: ''
    }
  },
  created: function () {
    this.$emit('updateTitle', this.moduleName + ' ' + this.$translate.t('Create'))
    this.createAction = this.apiUrl + '/create'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/custom/CustomCreateModule.vue